import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";

export default class SymbolGreen extends Symbol {
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        this.texture = PIXI.Texture.from("symbol_Green_particle.png");
    }

    // dlzka 830ms
    startParticles(symbol) {
        return new Promise(res => {
            let pt = [
                {x: symbol.x, y: symbol.y},
                {x: symbol.x+25, y: symbol.y+25},
                {x: symbol.x-25, y: symbol.y-25}
            ];
            createjs.Tween.get()
                .wait(230*this.speed)
                .call(() => {
                    SymbolAnim.runEmitter(this.createBigEmitter(pt[0].x, pt[0].y));
                })
                .wait(600*this.speed)
                .call(() => {
                    this.createSpark(pt[1].x, pt[1].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[1].x, pt[1].y));
                })
                .wait(200*this.speed)
                .call(() => {
                    this.createSpark(pt[2].x, pt[2].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[2].x, pt[2].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    res();
                });
        })
    }

}